import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a1d18ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "GoogleSigninButton",
  ref: "googleButtonElement",
  "aria-label": "Sign in with Google"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, null, 512 /* NEED_PATCH */))
}